import { render, staticRenderFns } from "./RichTextButton.vue?vue&type=template&id=7927846a&"
import script from "./RichTextButton.vue?vue&type=script&lang=js&"
export * from "./RichTextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports